import { render, staticRenderFns } from "./editArchive.vue?vue&type=template&id=3691d458&"
import script from "./editArchive.vue?vue&type=script&lang=js&"
export * from "./editArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports